import { useQuery } from "@tanstack/react-query";

import { getCarbonProgramDrafts } from "services";

import { GET_CARBON_PROGRAM_DRAFTS } from "consts";

import { CarbonProgramDraftSummary } from "models";

export const useGetCarbonProgramDrafts = () =>
  useQuery<CarbonProgramDraftSummary[]>({
    queryKey: [GET_CARBON_PROGRAM_DRAFTS],
    queryFn: () => getCarbonProgramDrafts(),
    refetchOnMount: "always",
  });
